module.exports = __webpack_public_path__ + "img/checking_on_light.f93647de.svg";